module.exports = __webpack_public_path__ + "img/Yolandi Rossouw.6aae9525.png";